"use client"

export default function MinimalFooter() {
    return (
        <footer className="border-t-8 border-foreground bg-background py-12">
            <div className="max-w-7xl mx-auto px-6">
                {/* Grid Layout */}
                <div className="grid grid-cols-3 gap-px bg-foreground mb-8">
                    <div className="bg-background p-6 text-center">
                        <p className="font-mono text-xs uppercase tracking-widest">SYNCTECH</p>
                    </div>
                    <div className="bg-background p-6 text-center">
                        <p className="font-mono text-xs uppercase tracking-widest">2026</p>
                    </div>
                    <div className="bg-background p-6 text-center">
                        <p className="font-mono text-xs uppercase tracking-widest">MENU</p>
                    </div>
                </div>

                {/* Bottom */}
                <div className="text-center">
                    <div className="inline-block border-4 border-foreground px-6 py-3 font-mono font-bold uppercase text-sm">
                        POWERED BY SYNCTECH
                    </div>
                    <p className="mt-4 font-mono text-xs text-foreground/50 uppercase tracking-widest">
                        ALL RIGHTS RESERVED
                    </p>
                </div>
            </div>
        </footer>
    )
}
